import React from 'react';

export function checkAuth(authinfo){
    const result = authinfo && authinfo.user && authinfo.user.expires_at && new Date() < new Date(authinfo.user.expires_at);
    return result;
}